module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
// AMC_Banner Widget

(function (fox, $) {
	"use strict";
	fox.registerWidget('Menu_Main', {

		configure: function () {
			this.registerOptions('', {
				container: '.main-menu-container',
				limits: {
					minWidth: 901
				},

				handleWom: {
					addedToDom:{
						widget: '@parent #langSwitcher',
						event: 'addedToDom',
						callback: 'initMenu'
					},
					resize: {
						widget: '@this',
						event: 'resize',
						callback: 'initMenu'
					},
				},

			});
			this.callParent('configure', arguments);
		},

		initMenu: function () { 
			this.checkLink();
			if(this.getOption('limits.minWidth') > $(document).width()){
				return;
			}

			var $cont = $(this.getOption('container'));

			this.menu = {
				items: {},
				totalW: 0,
			};

			var that = this;

			$cont.find('[fox-main-menu-item]').each(function (i, elt) {
				var el = $(elt);
				var w = el.is(':visible') ? el.width() + 9 : 0;

				that.menu.totalW += w;
				that.menu.count= i + 1;
				that.menu.items[el.attr('fox-main-menu-item')] = {
					el: el.parent(),
					w: w,
					additional: false
				};
			});
			$('.more-menu').off('click');
			$('.more-menu').on('click', function(event){
				$('.additional-menu').toggleClass('active');
				$('.more-menu').toggleClass('active');
			});

			$cont = $(this.getOption('container'));
			var $more = $('.more-menu');
			var totalWidth = $cont.width();
			var eltSum = 80;

			this.menu.mainW = this.menu.mainW || that.menu.totalW;
			if (totalWidth > (this.menu.mainW + $more.width())) {
				$cont.css({opacity: 1});
				return;
			}

			this.menu.mainW = 0;
			this.menu.additionalW = 0;

			for(var item in this.menu.items){
				var t = this.menu.items[item].additional ? this.menu.additionalW += this.menu.items[item].w : this.menu.mainW += this.menu.items[item].w;
			}

			if (totalWidth < (this.menu.mainW + $more.width())) {

				if ($more.hasClass('active')) {
					eltSum += $more.width();
				}

				for(item in this.menu.items) {
					if (this.menu.items[item].additional === true) {
						continue;
					}

					if ((eltSum += this.menu.items[item].w) > totalWidth) {
						
						if (!$more.hasClass('show')){
							$more.addClass('show');
						}

						this.menu.items[item-1].el.detach();
						$('.additional-menu').append(this.menu.items[item-1].el);
						this.menu.items[item-1].additional = true;

						if(item === this.menu.count){
							this.menu.items[item].el.detach();
							$('.additional-menu').append(this.menu.items[item].el);
							this.menu.items[item].additional = true;
						}
					} 
				}
			} else {
				if ($more.hasClass('active')) {
					totalWidth -= ($more.width() + 80);
				}
				for(item in this.menu.items) {

					if (this.menu.items[item].additional === false) {
						continue;
					}

					if ((this.menu.mainW += this.menu.items[item].w) < totalWidth) {
						this.menu.items[item].el.detach();
						$('.main-menu').append(this.menu.items[item].el);
						this.menu.items[item].additional = false;

						if (item === this.menu.count ) {
							if ($more.hasClass('show')){
								$more.removeClass('show');
							}
						}
					}
				}
			}
			$cont.css({opacity: 1});
		},

		running: function (argument) {
			$(window).on('resize', {w: this}, this._handleResize);
			if (fox.utils.isTouchDevice()) {
				window.addEventListener("orientationchange", fox.bind(function() {
					this.getParent().render();
				}, this), false);
			}
			
			this.callParent('running', arguments);
		},

		_handleResize: function (e) {
			var _this = e.data.w;

			if (_this.timeId) {
				window.clearTimeout(_this.timeId);
			}

			_this.timeId = window.setTimeout(fox.bind(function () {
				_this.dispatchEvent('resize', {w: _this});
			}, _this), 100);
		},

		isTouchDevice: function () {
			var DocumentTouch;
			return ('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch;

		},

		checkLink: function () {
			this.currentLink = fox.Navigator.get(1) ? fox.Navigator.get(1) : fox.Navigator.get(0);
			this.markCurrentLink();
		},

		markCurrentLink: function () {
			$('#promo-top-menu a').each(fox.bind(function (i, el) {
				el = $(el);

				el.removeClass('active');
				if (el.attr('alias') === this.currentLink) {
					el.addClass('active');
					fox.Navigator.set(1, (this.currentLink === 'home' ? '' : this.currentLink));
				}

				
			}, this));
		}

	}, 'Controller');

})(fox, fox.jQuery);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/widget/menu/main.js
// module id = 328
// module chunks = 2